import { render, staticRenderFns } from "./BookingAddressCreateForm.vue?vue&type=template&id=796e7918&"
import script from "./BookingAddressCreateForm.vue?vue&type=script&lang=js&"
export * from "./BookingAddressCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports